import Vue from 'vue';
import '@ungp/sds-components-baseline/types';
import SdsComponentsBaseline from '@ungp/sds-components-baseline';

Vue.use(SdsComponentsBaseline);
